import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  settingsTabbedNav: {
    //
  },
  tabs: {
    borderColor: theme.tabs.borderColor,
    "& li": {
      "& button": {
        marginRight:"16px",
        "&.nav-link": {
          border: "none",
          borderColor: theme.tabs.borderColor,
          color: theme.tabs.color,
          fontWeight:"600",
          padding: "0px 4px 9px",
          "&.active": {
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
          "&:hover":{
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          }
        },
        "&:focus-visible":{
          boxShadow: "0px 0px 0px 4px " + colors.primary500Blue
        },
      }
    }
  },
  hideTabs: {
    display: "none",
  }
}));

export default styles;

export const tabsSelectOpen = {
  dropdownIndicator: (base, { selectProps }) => ({
    ...base,
    padding:"12px",
    transition: selectProps.menuIsOpen ? 'all .2s ease' : "none",
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : "none",
    color: `${colors.grey} !important`,
  }),
}